<template>
    <div class="feature-view" style="margin-top: 5rem;">
        <div class="feature-view-navigation">
            <FeatureNavigation
                :actions="accountActions"
                @action="actionEmitted"
                ref="navigation"
            ></FeatureNavigation>
        </div>
        <div class="feature-view-content">
            <EditSection
                accent="apple"
                :errors="errors"
                :loading="initLoading"
                :sections="accountSections"
                :title="$t('MENU_SETTINGS')"
                @entered="submit"
                @openModal="openModal"
                ref="accountSections"
                section="accountSections"
            ></EditSection>
            <transition name="fade">
                <PasswordSettings
                    @close="passwordModalVisible = false"
                    @updated="
                        getAccount
                        passwordModalVisible = false
                    "
                    v-if="passwordModalVisible"
                ></PasswordSettings>
                <EmailSettings
                    @close="emailModalVisible = false"
                    @updated="getAccount"
                    v-if="emailModalVisible"
                ></EmailSettings>
                <RemoveAccount
                    @close="deleteModalVisible = false"
                    v-if="deleteModalVisible"
                ></RemoveAccount>
            </transition>
        </div>
    </div>
</template>
<script>
import PasswordSettings from '@/components/account/PasswordSettings.vue'
import EmailSettings from '@/components/account/EmailSettings.vue'
import RemoveAccount from '@/components/account/RemoveAccount.vue'
export default {
    components: {
        PasswordSettings,
        RemoveAccount,
        EmailSettings
    },
    data() {
        return {
            initLoading: false,
            errors: new this.$Errors(),
            accountSections: {
                avatar: {
                    title: this.$t('AVATAR'),
                    value: '',
                    type: 'avatar-input',
                    key: 'avatar'
                },
                name: {
                    required: true,
                    title: this.$t('LABEL_FIRSTNAME'),
                    value: '',
                    type: 'text-input',
                    key: 'name',
                    color: '#FFF',
                    size: 2
                },
                surname: {
                    required: true,
                    title: this.$t('LABEL_LASTNAME'),
                    value: '',
                    type: 'text-input',
                    key: 'surname',
                    color: '#FFF',
                    size: 2
                },
                mail: {
                    required: true,
                    title: this.$t('LABEL_EMAIL'),
                    value: '',
                    type: 'modal-input',
                    color: '#FFF',
                    key: 'mail',
                    size: 1
                },
                phone: {
                    required: true,
                    title: this.$t('PHONE'),
                    value: '',
                    type: 'number-input',
                    color: '#FFF',
                    key: 'phone',
                    size: 1
                }
            },
            passwordModalVisible: false,
            deleteModalVisible: false,
            emailModalVisible: false
        }
    },
    computed: {
        accountBillsVisible() {
            const store = this.$store.state
            return (
                store.user.type == 'parent' &&
                store.school.features.parent_invoicing
            )
        },
        accountActions() {
            let actions = [
                {
                    display: this.$t('LABEL_CHANGE_PASS'),
                    action: 'changePassword',
                    type: 'primary',
                    materialIcon: 'loop',
                    color: 'apple'
                }
            ]
            actions.push({
                display: this.$t('LABEL_DELETE_ACCOUNT'),
                action: 'deleteAccount',
                type: 'primary',
                color: 'red',
                materialIcon: 'delete'
            })

            return actions
        }
    },
    methods: {
        openModal(section) {
            if (section.key == 'mail') {
                this.emailModalVisible = true
            }
        },
        actionEmitted(action) {
            switch (action) {
                case 'changePassword':
                    this.passwordModalVisible = true
                    break
                case 'deleteAccount':
                    this.deleteModalVisible = true
                    break
            }
        },
        editAvatar(payload) {
            let data = { avatar: '' }
            if (payload.action == 'add') {
                data.avatar = payload.files[0].path
            }
            this.$apiService
                .editAccount(data)
                .catch(error => {
                    this.$Network.handleError(error, this.errors)
                })
                .then(() => {
                    this.getAccount()
                    this.loading = false
                })
        },
        getAccount() {
            this.$apiService
                .getAccount()
                .then(data => {
                    Object.keys(data).forEach(key => {
                        if (this.accountSections[key]) {
                            if (key == 'avatar') {
                                this.accountSections[key].value = data[key]
                            } else {
                                this.accountSections[key].value = data[key]
                            }
                        }
                    })
                    if (!data.language) {
                        this.accountSections.language.value = this.$i18n.locale
                    }
                })
                .catch(error => {
                    this.$Network.handleError(error, this.errors)
                })
                .then(() => {
                    this.initLoading = false
                    this.$store.commit('setLoading', false)
                    this.$forceUpdate()
                })
        },
        submit(section, sectionName) {
            if (this.$store.state.loading) {
                return
            }
            let data = {}
            if (section.key == 'phone') {
                data.phone = `${section.value}`
            } else {
                data[section.key] = section.value
            }
            this.$store.commit('setLoading', true)
            this.$apiService
                .editAccount(data)
                .then(() => {
                    if (section.key == 'language') {
                        location.reload()
                    }
                    this.$refs[sectionName].success(section)
                })
                .catch(error => {
                    if (this.$refs[sectionName]) {
                        this.$refs[sectionName].error(section)
                    }
                    this.$Network.handleError(error, this.errors)
                })
                .then(() => {
                    this.getAccount()
                })
        }
    },
    mounted() {
        this.getAccount()
    }
}
</script>
